import { IGroup } from 'v3/data/store/group/types';

export interface IGroupAdminModalProps {
  modal: IModal;
  fullStoreGrouplist: IGroup[];
  adminStoreGroupList?: { storeGroup: storeGroupList }[];
  onClose: () => void;
  onConfirm: (data, reset: Function) => void;
}

export interface ICreateGroupAdminForm {
  email: string;
  password: string;
  confirmPassword: string;
  name: string;
  storeGroupIds: string[];
}

export interface IModal {
  active: boolean;
  title: string;
  cancelButton: string;
  saveButton: string;
  initialState?: ICreateGroupAdminForm;
  mode: Mode;
}

export interface storeGroupList {
  id: string;
  name: string;
}

export enum Mode {
  Create = 'create',
  Edit = 'edit',
}
